import { useTranslation } from 'react-i18next';
import { Divider, Button } from '@treezor/design-system';

import { useCreatePasskey } from '../hooks/useCreatePasskey';

export function Auth2FaRegistrationFail() {
  const { t } = useTranslation();
  const { register2Fa, isLoading } = useCreatePasskey();

  return (
    <div className="flex flex-col">
      <span className="typo-body-regular-paragraphLarge text-primary">{t('pages.auth.2fa.failTitle')}</span>
      <Divider className="my-4" />
      <span className="typo-body-semibold-paragraph text-secondary mb-2">
        {t('pages.auth.2fa.failDescription.title')}
      </span>
      <>
        {['0', '1'].map((key) => (
          <span key={`fail-description-${key}`} className="typo-body-regular-paragraph text-secondary">
            {t(`pages.auth.2fa.failDescription.${key}`)}
          </span>
        ))}
      </>
      <Button onClick={register2Fa} isLoading={isLoading} className="w-fit mt-6">
        {t('pages.cores.tryAgain')}
      </Button>
    </div>
  );
}
